import { render, staticRenderFns } from "./TestFolders.vue?vue&type=template&id=0ef3a184&scoped=true&"
import script from "./TestFolders.vue?vue&type=script&lang=js&"
export * from "./TestFolders.vue?vue&type=script&lang=js&"
import style0 from "./TestFolders.vue?vue&type=style&index=0&id=0ef3a184&lang=scss&scoped=true&"
import style1 from "./TestFolders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3a184",
  null
  
)

export default component.exports